export enum DimensionField {
  LENGTH = "length",
  WIDTH = "width",
  HEIGHT = "height",
  WEIGHT = "weight",
}
